var swiperGallery = new Swiper('.imageGallery', {
    spaceBetween: 12,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      300: {
        slidesPerView: 3.5,
        direction: 'horizontal',
      },
      768: {
        slidesPerView: 7,
        direction: 'horizontal',
      },
      1024: {
        direction: 'vertical',
        slidesPerView: 7,
      },
    },
  });
  var swiperFeatured = new Swiper('.focusedImage', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiperGallery,
    },
    on: {
      // Listen for the slide change event
      slideChange: function () {
        document.querySelector('.focusedImage').classList.add('is--scrolled');
        const videos = document.querySelectorAll('video');
        if (videos.length == 0) return;
        videos.forEach((video) => {
          video.pause(); // Pause all videos
          video.currentTime = 0; // Reset to the beginning
        });
        const activeSlide = this.slides[this.activeIndex];
        const videoInActiveSlide = activeSlide.querySelector('video');
        if (videoInActiveSlide) {
          videoInActiveSlide.play(); // Play the video in the active slide
        }
      },
    },
  });